import React from 'react'
import { Card, CardBody, CardHeader } from 'reactstrap'
import CardTextData from 'components/molecules/card-text-data'
import PropTypes from 'prop-types'
import { DEBIT_BANKS } from 'domains/customer-refund-payment/constants'
import PriceUtil from 'utils/price-util'
import { InputField, DateInputField } from 'components'
import { Formik, Form } from 'formik'
import LoaderButton from 'components/molecules/loader-button'
import { CustomerRefundPaymentImageUpload } from 'domains/customer-refund-payment/atoms'
import { CurrencyInputField } from 'components/molecules'
import customerRefundPaymentFormSchema from './customer-refund-payment-form-schema'
import StringUtil from 'utils/string-util'

const propTypes = {
  paidItemPrice         : PropTypes.string,
  setImage              : PropTypes.func,
  handleCompletePayment : PropTypes.func,
  refundMethod          : PropTypes.string
}

const defaultProps = {
  paidItemPrice         : '',
  setImage              : () => {alert('set image function triggered')},
  handleCompletePayment : () => {}
}

const CustomerRefundPaymentForm        = ({
  paidItemPrice,
  setImage,
  handleCompletePayment,
  refundMethod
}) => (
  <Formik
    initialValues={{
      transaction_no : '',
      tl_bank_id     : '',
      transferred_at : '',
      refund_method  : refundMethod
    }}
    validationSchema={ customerRefundPaymentFormSchema }
    onSubmit={ handleCompletePayment }
  >
    {
      (formikBag) => (
        <Card>
          <Form>
            <CardHeader>Payment Detail</CardHeader>
            <CardBody>
              <CardTextData
                label='Refund Method'
                value={ StringUtil.humanizeUpperCase(refundMethod) }
              />
              <CardTextData
                label='Paid Item Price'
                value={ PriceUtil.format(paidItemPrice) }
              />

              <InputField
                label={ refundMethod == 'credit_card' ? 'Card Number' : 'Transaction No.' }
                type='text'
                name='transaction_no'
              />

              {
                refundMethod == 'cash' && (
                  <>
                    <InputField
                      label='Debit Bank'
                      type='select'
                      name='tl_bank_id'
                      required={ true }
                    >
                      {
                        DEBIT_BANKS.map((element, index) => (
                          <option
                            key={ index }
                            value={ element.value }
                          >
                            { element.label }
                          </option>
                        ))
                      }
                    </InputField>

                    <CurrencyInputField
                      label='Payment Cost'
                      name="payment_cost"
                      formText="biaya tambahan dari transfer antar bank"
                    />
                  </>
                )
              }

              <DateInputField
                label='Transferred at'
                name='transferred_at'
                dateFormat="dd/MM/yyyy"
                maxDate={ new Date() }
              />

              <CardTextData
                label='Transfer Evidence'
                value={
                  <CustomerRefundPaymentImageUpload setImage={ setImage } />
                }
              />
              <LoaderButton
                color='success'
                className="float-right mb-3"
                isLoading={ formikBag.isSubmitting }
                type="submit"
                text={ 'Transfer' }
              />
            </CardBody>
          </Form>
        </Card>
      )
    }
  </Formik>
)
CustomerRefundPaymentForm.propTypes    = propTypes
CustomerRefundPaymentForm.defaultProps = defaultProps

export default CustomerRefundPaymentForm
